<template>
    <div class="usage-table mt-5 mb-5">
      <h2>{{ title }}</h2>
      <v-data-table :items="tableData">
      </v-data-table>
    </div>
  </template>


  <script>
  export default {
    name: 'UsageTable',
    props: {
      title: {
        type: String,
        required: true
      },
      tableData: {
        type: Array,
        required: true
      }
    }
  };
  </script>

  <style scoped>
    .usage-table {
        width: 33%;
        margin-right: 10px;
        min-width: 250px;
        @media screen and (max-width: 767px){
          width: 100%;
        }
    }
</style>
